module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Purchased: His Perfect Wife")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle0"
  })]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "paraCenter"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Legally wed,"), _c('br'), _vm._v("\nbut he’s never said,"), _c('br'), _vm._v("\n“I love you.”")])])])]), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("They’re…")])])])]), _c('p', {
    staticClass: "CenterImage"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/sub.jpg"
    }
  })])]), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The series where marriages are made"), _c('br'), _vm._v("\nin haste…and love comes later.")])])])]), _c('br'), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Look out for more WEDLOCKED!"), _c('br'), _vm._v("\nwedding stories available only from"), _c('br'), _vm._v("\nHarlequin Presents")])]), _c('sup', [_vm._v("®")]), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v(".")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9b862aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/purchasedhisperfectwife_fm02.vue
// module id = 60
// module chunks = 0